module.exports = __webpack_public_path__ + "static/img/noAauthority.3348073.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/noAauthority.png
// module id = 12w/
// module chunks = 2